export default "__VITE_ASSET__CiPDXf0d__"